/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="95.58"
        viewBox="0 0 95.58 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M47.79 0a47.79 47.79 0 1 0 47.79 47.79A47.85 47.85 0 0 0 47.79 0Zm0 2.5A45.29 45.29 0 1 1 2.5 47.79 45.29 45.29 0 0 1 47.79 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M47.79 44.67a3.13 3.13 0 1 0 3.13 3.13 3.12 3.12 0 0 0-3.12-3.12"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M47.79 43.42a4.38 4.38 0 1 0 4.38 4.38 4.37 4.37 0 0 0-4.37-4.37Zm0 2.5a1.88 1.88 0 1 1-1.87 1.89 1.88 1.88 0 0 1 1.87-1.89Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M47.79 7.5a1.26 1.26 0 0 1 1.25 1.12v10.27a1.25 1.25 0 0 1-1.28 1.22 1.23 1.23 0 0 1-1.21-1.09V8.78a1.25 1.25 0 0 1 1.22-1.28ZM19.43 19.43a1.23 1.23 0 0 1 1.67-.09l.1.09 7 7a1.25 1.25 0 0 1-1.67 1.86l-.1-.09-7-7a1.25 1.25 0 0 1 0-1.77ZM18.89 46.5a1.252 1.252 0 0 1 .13 2.5H8.78a1.25 1.25 0 0 1-.13-2.49h10.24ZM26.5 67.29a1.27 1.27 0 0 1 1.77 0 1.24 1.24 0 0 1 .09 1.67l-.09.1-7.16 7.23a1.25 1.25 0 0 1-1.76 0 1.26 1.26 0 0 1-.1-1.67l.1-.1ZM47.79 75.69a1.26 1.26 0 0 1 1.25 1.12v10a1.25 1.25 0 0 1-1.28 1.22 1.23 1.23 0 0 1-1.21-1.09v-10a1.25 1.25 0 0 1 1.24-1.25ZM67.33 67.29a1.28 1.28 0 0 1 1.65 0l.1.09 7.15 7.15a1.25 1.25 0 0 1 0 1.77 1.28 1.28 0 0 1-1.67.09l-.1-.09-7.15-7.15a1.27 1.27 0 0 1 .02-1.86ZM86.8 46.5a1.252 1.252 0 0 1 .13 2.5H76.69a1.25 1.25 0 0 1-.13-2.49H86.8ZM74.5 19.34a1.25 1.25 0 0 1 1.77 0 1.27 1.27 0 0 1 .09 1.63l-.09.1-7.17 7.22a1.25 1.25 0 0 1-1.77 0 1.27 1.27 0 0 1-.09-1.67l.09-.1Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M59.61 16.14a1.253 1.253 0 1 1 2.36.84v.12L48.98 48.29a1.27 1.27 0 0 1-1.52.72h-.12l-21.67-9a1.26 1.26 0 1 1 .84-2.37h.12l20.52 8.5Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'ClockIcon';

export default Icon;
